import { useState } from 'react';

import { ReleaseGroup } from './login.types';

const useReleaseGroup = () => {
  const [releaseGroup, setReleaseGroup] = useState<ReleaseGroup>();
  return { releaseGroup, setReleaseGroup };
};

export default useReleaseGroup;
